import { signal } from "@preact/signals";
import type { VenueId } from "@orderman/shared";
import { getDeviceId, setDeviceToken, setDeviceName, setDeviceOwnerClass, updateSettings } from "./config.js";
import { relayBase } from "./store.js";

/**
 * Beitritt per EINEM Code (kein Slug/URL-Zusatz mehr): Das Gerät öffnet kasse-…/ und tippt einen
 * Code. Der Server (join.php) bestimmt anhand des Codes die Rolle + das Ziel:
 *  - Betreiber-Code (1 h) → owner_class=betreiber, ohne Veranstaltung, Inventarnummer.
 *  - Event-Passwort einer laufenden Veranstaltung → byd, dieser Venue zugewiesen.
 * Ersetzt den QR-Enroll + „Freischalten" für Handys. Betreiber-/LAN-QR (?enroll=) bleibt separat.
 */

/** „Gerät neu einrichten" (Code-Screen) manuell öffnen — z. B. um zu einem anderen Event zu wechseln. */
export const manualJoin = signal(false);

// Origin (LAN-Proxy) zuerst, dann relayBase (reine Cloud/Mobilfunk) — der kasse-vhost ist statisch,
// die PHP-Endpunkte liegen unter dem Cloud-Host.
function bases(): string[] {
  return [location.origin, relayBase()].filter((b, i, a) => a.indexOf(b) === i);
}

/** Mit einem Code beitreten. Token/Name (+ Venue bei byd) speichern. Wirft mit Klartext-Grund. */
export async function submitCode(code: string, name: string): Promise<void> {
  const body = JSON.stringify({ deviceId: getDeviceId(), code: code.trim(), name: name.trim() });
  let lastErr = "Server nicht erreichbar";
  for (const base of bases()) {
    let j: { ok?: boolean; error?: string; deviceToken?: string; venueId?: string | null; name?: string; ownerClass?: string };
    try {
      const res = await fetch(`${base}/join.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
      });
      j = (await res.json()) as typeof j;
    } catch {
      lastErr = "nicht erreichbar";
      continue; // HTML-404 vom statischen vhost o. Ä. → nächste Basis
    }
    if (j.ok === undefined && j.error === undefined) { lastErr = "unerwartete Antwort"; continue; }
    if (!j.ok) throw new Error(j.error || "Code ungültig");
    if (j.deviceToken) setDeviceToken(j.deviceToken);
    if (j.name) setDeviceName(j.name);
    setDeviceOwnerClass(j.ownerClass); // 'betreiber' → kein „Gerät neu einrichten"
    if (j.venueId) updateSettings({ venueId: j.venueId as VenueId }); // byd → gleich auf die Venue
    return;
  }
  throw new Error(lastErr);
}
